import { ContractsStore } from "../../store/modules/contracts";
import { PersonStore } from "../../store/modules/person";
import { CatalogStore } from "../../store/modules/catalog";
import { TemplatesStore } from "../../store/modules/templates";
import { getModule } from "vuex-module-decorators";
import { BaseLayoutVue } from "./BaseLayoutVue";

/**Модель представления авторизованной страницы */
export class MainLayoutVue extends BaseLayoutVue {
  /**Стор счетов */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  /** Стор личных данных пользователя */
  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  get catalogStore(): CatalogStore {
    return getModule(CatalogStore, this.$store);
  }

  get templatesStore(): TemplatesStore {
    return getModule(TemplatesStore, this.$store);
  }

  resetStoreStates() {
    this.contractsStore.resetStates();
    this.personStore.resetStates();
    this.catalogStore.resetStates();
    this.templatesStore.resetStates();
  }

  /**Инициализация стартовых данных приложения */
  async init(): Promise<void> {
    super.init();
    await this.personStore.fetchPersonInfo();
    await this.contractsStore.fetchContracts();
    await this.personStore.fetchNotifications();
    if (this.$route.name === 'Payments') {
      if (!this.$route.query.query)
        await this.catalogStore.fetchCatalog(0);
    } else
      await this.catalogStore.fetchCatalog(0);
    await this.templatesStore.fetchTemplates();
  }
}
